module.exports = __webpack_public_path__ + "img/woa-qrcode.f7b50a8c.jpg";